import script from "./AnchorNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnchorNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./AnchorNavigation.vue?vue&type=style&index=0&id=4f024d29&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f024d29"]])

export default __exports__